import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'true-about',
    templateUrl: './flow.component.html',
    styleUrls: ['../section-overview/section-overview.component.scss'],
    standalone: false
})
export class FlowComponent implements OnInit {  
  constructor(private dialogRef: MatDialogRef<FlowComponent>, private router: Router, private route: ActivatedRoute) { }

  routeMap: { [key: string]: string } = {
    canvas: 'trl',    
    trl: 'brief',
    brief: 'nodes',
    nodes: 'home'
  };

  ngOnInit(): void {
  }

  close():void {
    this.dialogRef.close();
  } 

  next(): void {
    const currentRoute = this.router.url.split('/').pop() || '';
    const nextRoute = this.routeMap[currentRoute];  
    if (nextRoute) {
      this.router.navigate([nextRoute]);
    } else {
      console.warn('No next step defined for:', currentRoute);
    }  
    this.close();
  }


}
